export const version = "1.0.2-daily-20240717-0";
export const channel = "daily";
export const gitcommit = "ae797f6da";
